import { useTranslation } from "react-i18next";
import { FormSection, FormSectionStack } from "@/features/admin/components";
import { ProductCurrencyRows } from "../ProductCurrencyRows";

/**
 * ═══════════════════════════════════════════════════════════════════
 * Paso 3 · Los precios por país.
 *
 * Se teclea en PESOS —"1299.50", como se lee un precio— y lo que viaja
 * al API son centavos enteros. La conversión ocurre en un único sitio
 * (`productFormSchema` → `parsePriceToCents`): 0.1 + 0.2 no es 0.3 en
 * punto flotante, y un catálogo que se suma miles de veces al día
 * acumula ese error hasta que un total no cuadra y nadie sabe dónde
 * empezó.
 *
 * ── Los tres precios de la lista de Anahí, y NADA más (26-ago) ──────
 * "Precio público, precio socio y precio franquiciatario; solo Estados
 * Unidos y México". Los dos primeros se ESCRIBEN, uno por moneda: no
 * hay porcentaje que los relacione —EVA Plus va de 1,470.00 a 1,250.00
 * en pesos (14.97 %) y de 74.00 a 63.00 en dólares (14.86 %)— así que
 * son dos importes negociados y no una rebaja. El de FRANQUICIATARIO
 * se calcula del porcentaje que se escribe en el propio paso, sobre el
 * precio de socio.
 *
 * ── Qué salió de aquí en la segunda pasada ──────────────────────────
 * La tarjeta de "Descuentos" entera: el precio tachado y el descuento
 * general no están en la lista de ella. El descuento sigue existiendo
 * para las PROMOCIONES, y se edita donde una promoción se define — el
 * paso 2, junto a sus fechas (`ProductPromotionFields`).
 * ═══════════════════════════════════════════════════════════════════
 */
export function PricingStep() {
  const { t } = useTranslation();

  return (
    <FormSectionStack>
      <FormSection
        title={t("Precios por país")}
        columns={1}
        compact
      >
        <ProductCurrencyRows />
      </FormSection>
    </FormSectionStack>
  );
}
